import { render, staticRenderFns } from "./WdfGenerateLinkModal.vue?vue&type=template&id=06a7904d"
import script from "./WdfGenerateLinkModal.vue?vue&type=script&lang=js"
export * from "./WdfGenerateLinkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports